export const toDateString = (datetime?: Date | string | null): string => {
  if (!datetime) return '';
  const date = new Date(datetime);
  if (isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
};
